import React from "react";
import styles from "./Footer.module.css";

function Footer() {
  return (
    <footer className={styles.footer}>
      <a href="mailto:ashish.hudar@gmail.com" className={styles.email}>
        ashish.hudar@gmail.com
      </a>
      <span className={styles.copy}>
        built with coffee © {new Date().getFullYear()}
      </span>
    </footer>
  );
}

export default Footer;
